import React from "react";
import { useParams } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button } from "react-bootstrap";
import { FaTimes, FaCheck } from "react-icons/fa";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import Meta from "../../components/Meta";
import { useGetCareerQuery } from "../../slices/submissionApiSlice";
import GenericPaginateAdmin from "../../components/GenericPaginateAdmin";

const CareerListScreen = () => {
  const { pageNumber } = useParams();
  const { data, isLoading, error } = useGetCareerQuery({ pageNumber });

  return (
    <>
      <Meta
        title="Career Applications List | Admin | Lugo Parts & Restoration"
        description="Admin panel for managing career opportunities at Lugo Parts & Restoration."
      >
        <meta name="robots" content="noindex, nofollow" />
      </Meta>

      <h1>Career Applications</h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          <Table striped hover responsive className="table-sm">
            <thead style={{ whiteSpace: "nowrap" }}>
              <tr>
                <th>ID</th>
                <th>NAME</th>
                <th>EMAIL</th>
                <th>PHONE</th>
                <th>JOB CATEGORY</th>
                <th>COVER LETTER</th>
                <th>RESUME</th>
                <th>Submitted On (PT)</th>
                <th>DETAILS</th>
              </tr>
            </thead>
            <tbody>
              {data.careers.map((career) => (
                <tr key={career._id}>
                  <td>{career._id}</td>
                  <td>{career.name}</td>
                  <td>{career.email}</td>
                  <td>{career.phone}</td>
                  <td>{career.jobCategory}</td>
                  <td>
                    {career.coverLetter ? (
                      <FaCheck style={{ color: "green" }} />
                    ) : (
                      <FaTimes style={{ color: "red" }} />
                    )}
                  </td>
                  <td>
                    {career.resume ? (
                      <FaCheck style={{ color: "green" }} />
                    ) : (
                      <FaTimes style={{ color: "red" }} />
                    )}
                  </td>
                  <td>
                    {new Date(career.createdAt)
                      .toLocaleString("en-US", {
                        timeZone: "America/Los_Angeles", // Pacific Time (PT)
                        hour12: false,
                      })
                      .substring(0, 19) + " (PT)"}
                  </td>
                  <td>
                    <LinkContainer to={`/admin/career/${career._id}`}>
                      <Button variant="light" className="btn-sm">
                        Details
                      </Button>
                    </LinkContainer>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <GenericPaginateAdmin
            pages={data.pages}
            page={data.page}
            type="career"
          />
        </>
      )}
    </>
  );
};

export default CareerListScreen;
